import { isArray, isObject, toString } from "lodash";
import JSON5 from "json5";

export const resultToString = (result: unknown) =>
  isObject(result) || isArray(result)
    ? JSON5.stringify(result)
    : toString(result);
